import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Qu'est-ce qu'un Certificat d'Économies d'Énergie (CEE) ?",
    a: "Le CEE est une preuve d'économie d'énergie générée par une action concrète (isolation, pompe à chaleur, récupération de chaleur…). Chaque kWh cumac économisé sur la durée de vie de l'équipement génère des certificats, valorisés financièrement par les fournisseurs d'énergie soumis à obligation.",
  },
  {
    q: "Qui peut bénéficier des CEE ?",
    a: "Toute personne physique ou morale réalisant des travaux d'efficacité énergétique éligibles : entreprises (industrie, tertiaire), collectivités, bailleurs, copropriétés, particuliers. Aucune condition de taille minimale.",
  },
  {
    q: "Combien représente une prime CEE ?",
    a: "Le montant dépend de l'opération, du volume de kWh cumac généré et du cours CEE en vigueur. À titre indicatif, une chaudière biomasse industrielle peut générer entre 30 000 € et 250 000 € de CEE selon la puissance.",
  },
  {
    q: "Est-ce qu'ECONATION facture ses services ?",
    a: "L'audit d'éligibilité, l'étude technique préliminaire et le montage du dossier sont entièrement gratuits. Notre rémunération est intégrée à la valorisation CEE — vous bénéficiez d'une offre nette, sans coût caché.",
  },
  {
    q: "Combien de temps prend un dossier CEE ?",
    a: "De la 1ʳᵉ visite à la validation : 4 à 8 semaines pour les opérations standardisées ; 8 à 14 semaines pour les opérations spécifiques. Le versement intervient après réception des travaux et contrôle qualité.",
  },
  {
    q: "Quelle est la différence entre opération standardisée et spécifique ?",
    a: "Une opération standardisée suit une fiche officielle (BAR/BAT/IND/RES) avec un calcul forfaitaire. Une opération spécifique nécessite une étude énergétique sur mesure (souvent pour les procédés industriels innovants). ECONATION traite les deux.",
  },
  {
    q: "Mes travaux sont déjà réalisés, puis-je encore en bénéficier ?",
    a: "Non. La règle d'antériorité impose qu'un devis CEE soit signé AVANT toute commande de travaux. Si vous envisagez un projet, contactez-nous en amont — c'est la condition légale.",
  },
  {
    q: "ECONATION réalise-t-il les travaux ?",
    a: "ECONATION pilote, coordonne et contrôle les travaux. Ils sont exécutés par des partenaires certifiés RGE / QUALIBAT / QUALIFELEC sélectionnés selon votre projet et votre zone géographique.",
  },
  {
    q: "Quelle garantie sur les économies promises ?",
    a: "Nous appliquons le protocole IPMVP (International Performance Measurement and Verification Protocol) avec un dispositif de mesure et vérification annuel sur 3 à 5 ans, selon l'opération.",
  },
  {
    q: "Les CEE sont-ils cumulables avec d'autres aides ?",
    a: "Oui, sous conditions : MaPrimeRénov', subventions ADEME, aides régionales, fonds chaleur… Le cumul est possible mais doit respecter un plafond global. Notre équipe optimise la pile d'aides pour chaque projet.",
  },
  {
    q: "Qu'est-ce qu'un kWh cumac ?",
    a: "« Cumac » = cumulé et actualisé. Un kWh cumac est un kWh économisé sur la durée de vie de l'équipement, actualisé à un taux annuel. C'est l'unité officielle des CEE.",
  },
  {
    q: "Le dispositif CEE va-t-il disparaître ?",
    a: "Non. Au contraire, il monte en puissance à chaque période quadriennale. La 5ᵉ période (2022-2025) a un objectif de 3 100 TWh cumac, et la 6ᵉ période est en préparation.",
  },
  {
    q: "Couvrez-vous toute la France ?",
    a: "Oui. ECONATION intervient sur l'ensemble du territoire métropolitain et DOM-TOM. Nos équipes terrain sont basées à Paris, Lyon, Marseille, Toulouse et Lille.",
  },
  {
    q: "Quels secteurs accompagnez-vous ?",
    a: "Industrie (agroalimentaire, chimie, métallurgie, plasturgie…), tertiaire (hôtellerie, santé, retail, bureaux, logistique), résidentiel (copropriétés, bailleurs sociaux, particuliers).",
  },
  {
    q: "Quelle taille de projet acceptez-vous ?",
    a: "À partir de 5 000 € de valorisation CEE. Nous accompagnons aussi bien des programmes multi-sites à plusieurs millions d'euros que des rénovations ciblées.",
  },
  {
    q: "Travaillez-vous avec des bureaux d'études externes ?",
    a: "Oui, en complément de notre bureau d'études interne. Nous savons collaborer avec votre BE habituel ou en mobiliser un de notre réseau selon la complexité du projet.",
  },
  {
    q: "Comment garantissez-vous la confidentialité ?",
    a: "Toutes nos missions sont couvertes par un accord de confidentialité (NDA) signé en amont. Les données techniques restent votre propriété exclusive.",
  },
  {
    q: "Que se passe-t-il en cas de contrôle PNCEE ?",
    a: "ECONATION constitue, archive et défend chaque dossier conformément aux exigences du Pôle National des Certificats d'Économies d'Énergie. Depuis nos débuts, 0 % de redressement.",
  },
  {
    q: "Quel est votre engagement RSE ?",
    a: "ECONATION publie chaque année un rapport d'impact (tCO₂ évitées, MWh économisés, projets accompagnés). Nous sommes signataires de la Charte d'Engagement CEE et certifiés ISO 50001.",
  },
  {
    q: "Comment démarre-t-on ?",
    a: "Trois minutes suffisent : remplissez le formulaire d'éligibilité ou appelez-nous au 01 86 90 14 48. Un chargé d'affaires vous recontacte sous 48 heures avec un premier diagnostic.",
  },
];

export default function FAQAccordion() {
  return (
    <section data-testid="faq-section" className="bg-white">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Questions fréquentes</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
            20 réponses pour tout comprendre des CEE.
          </h2>
        </div>

        <Accordion type="single" collapsible className="bg-white rounded-2xl border border-black/[0.06] divide-y divide-black/[0.06] overflow-hidden">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`q${i}`} className="border-0 px-6 md:px-8">
              <AccordionTrigger data-testid={`faq-q-${i + 1}`} className="text-left font-display text-base md:text-lg font-semibold text-[#0F172A] hover:no-underline py-5">
                <span className="flex items-start gap-4">
                  <span className="text-[#10B981] font-mono text-sm pt-0.5 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <span>{f.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-a-${i + 1}`} className="text-[#475569] leading-relaxed pb-6 pl-10 pr-2">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
